import styled from 'styled-components';

export const Thead = styled.thead`
  background: #333333;
  height: 30px;
  
`;

export const Th = styled.th`
  color: #fff;
  font-family: Inter;
  padding-left: 8px;
  font-size: 14px;
`;
